import React from 'react'
import _ from 'lodash'

import {Grid, Row, Col} from 'react-flexbox-grid'
import {Link} from 'react-router'

const NoNetworks = () => (
   <div style={{marginTop: '100px'}}>
      <div className="text-center">
         <h3 style={{fontWeight: 'bold'}}>Pick a network</h3>

         <p className="lead">
            Select a network from the menu to the left or go ahead and
            {' '}
            <Link to="/dashboard/setup">create a new one</Link>
         </p>
      </div>
   </div>
)

export const Overview = ({networks, router, Sidebar, ...props}) => {
   if (null !== networks && 0 === _.size(networks)) {
      router.push('/dashboard/setup?first=true')

      return null
   }

   return (
      <Grid className="networks no-menu">
         <Row>
            <Col xs={4}>
               <Sidebar router={router} {...props} />
            </Col>

            <Col xs={8}>
               <NoNetworks networks={networks} {...props} />
            </Col>
         </Row>
      </Grid>
   )
}

Overview.defaultProps = {
   Sidebar:  <div>No Aside defined</div>,
   networks: []
}

Overview.propTypes = {
   networks: React.PropTypes.array.isRequired,
   router:   React.PropTypes.object.isRequired,
   Sidebar:  React.PropTypes.any.isRequired
}

Overview.childRoutes = []



// WEBPACK FOOTER //
// lib/bundle/dashboard/networks/index.js